import { useState } from 'react';
import { Button, Menu, MenuItem, Typography, Box, Avatar, Chip } from '@mui/material';
import DownOutlined from '@ant-design/icons/DownOutlined';
import useCompany from 'contexts/CompanyContext';

const translateRole = (role: string): string => {
  const roleTranslations: Record<string, string> = {
    owner: 'Tulajdonos',
    manager: 'Menedzser',
    viewer: 'Megtekintő'
  };

  return roleTranslations[role.toLowerCase()] || role;
};

export default function CompanySelector() {
  const { companies, activeCompany, setActiveCompany } = useCompany();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCompanySelect = (company: any) => {
    setActiveCompany(company.company);
    handleClose();
  };

  return (
    <Box sx={{ width: '100%', ml: { xs: 0, md: 1 } }}>
      <Button onClick={handleClick} variant="outlined" endIcon={<DownOutlined />} sx={{ mr: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {activeCompany?.logo_url ? (
            <Box
              component="img"
              src={
                activeCompany.logo_url?.startsWith('http')
                  ? activeCompany.logo_url
                  : `${import.meta.env.VITE_APP_API_URL}${activeCompany.logo_url}`
              }
              alt={activeCompany.name}
              sx={{ height: 28, width: 'auto', maxWidth: 120 }}
            />
          ) : (
            <Avatar sx={{ width: 28, height: 28 }}>{activeCompany?.unique_identifier}</Avatar>
          )}
          <Typography variant="body2">{activeCompany?.name}</Typography>
        </Box>
      </Button>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {companies.map((membership) => (
          <MenuItem
            key={membership.company.id}
            onClick={() => handleCompanySelect(membership)}
            selected={activeCompany?.id === membership.company.id}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
              {activeCompany?.logo_url ? (
                <Box
                  component="img"
                  src={
                    activeCompany.logo_url?.startsWith('http')
                      ? activeCompany.logo_url
                      : `${import.meta.env.VITE_APP_API_URL}${activeCompany.logo_url}`
                  }
                  alt={activeCompany.name}
                  sx={{ height: 28, width: 'auto', maxWidth: 120 }}
                />
              ) : (
                <Avatar sx={{ width: 32, height: 32 }}>{activeCompany?.unique_identifier}</Avatar>
              )}
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="body2">{membership.company.name}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {membership.company.legal_name}
                </Typography>
              </Box>
              <Chip label={translateRole(membership.role)} size="small" variant="outlined" />
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
